export default "__VITE_ASSET__b5f712e3__"